module.exports = __webpack_public_path__ + "static/media/golfer-7-b.975a9b18.png";